import React from 'react';
import { Button } from '@mui/material';
import { motion } from 'framer-motion';

const MotionButton = motion(Button);

const AnimatedButton = ({
  label,
  onClick,
  icon,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  sx = {},
  ...rest
}) => {
  return (
    <MotionButton
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', stiffness: 300 }}
      variant={variant}
      color={color}
      startIcon={icon}
      onClick={onClick}
      disabled={disabled}
      sx={{
        px: 4,
        py: 1.5,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 1,
        borderRadius: 2,
        cursor: 'pointer',
        boxShadow:
          variant === 'contained'
            ? '0px 4px 20px rgba(0, 0, 0, 0.15)'
            : 'none',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow:
            variant === 'contained'
              ? '0px 6px 24px rgba(0, 0, 0, 0.25)'
              : 'none',
        },
        ...sx,
      }}
      {...rest}
    >
      {label}
    </MotionButton>
  );
};

export default AnimatedButton;
